module.exports = __webpack_public_path__ + "img/cf867c6fb777444c7e6a1a123bb9f32.f38850eb.jpg";